/* ShubVibes cards — Quick Add (size popover), single-variant AJAX add, Quick View.
   Reuses Dawn's cart-drawer: POST /cart/add.js then drawer.renderContents(). */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }

  function money(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }
  // Struck-through compare-at price is labelled MRP, matching the card and the PDP.
  function mrp(cents) {
    return 'MRP ' + Math.round(cents / 100).toLocaleString('en-IN');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addToCart(id, btn) {
    if (!id || id === '0') return Promise.resolve();
    var d = drawer();
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); }
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (d) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status) return; // e.g. sold out
      if (d && typeof d.renderContents === 'function' && state.sections) d.renderContents(state);
      else window.location = ROOT + 'cart';
    }).catch(function () { window.location = ROOT + 'cart'; })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); } });
  }

  /* ---- Quick Add popover + single-variant form ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sv-qa-toggle]');
    if (toggle) {
      var card = toggle.closest('.sv-card');
      var qa = card && card.querySelector('[data-sv-qa]');
      if (qa) {
        var opening = qa.hasAttribute('hidden');
        if (opening) { qa.removeAttribute('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
        else { qa.setAttribute('hidden', ''); toggle.setAttribute('aria-expanded', 'false'); }
      }
      return;
    }
    var sizeBtn = e.target.closest('[data-sv-qa-add]');
    if (sizeBtn && !sizeBtn.disabled) {
      addToCart(sizeBtn.getAttribute('data-sv-qa-add'), sizeBtn);
      return;
    }
    if (!e.target.closest('[data-sv-qa]')) {
      document.querySelectorAll('[data-sv-qa]:not([hidden])').forEach(function (qa) {
        qa.setAttribute('hidden', '');
        var t = qa.parentNode && qa.parentNode.querySelector('[data-sv-qa-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.sv-card__qaform');
    if (!form || !drawer()) return; // no drawer -> native POST fallback
    e.preventDefault();
    var idEl = form.querySelector('[name="id"]');
    addToCart(idEl && idEl.value, form.querySelector('button[type="submit"]'));
  });

  /* ---- Quick View modal ---- */
  var modal = null;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'sv-qv';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="sv-qv__overlay" data-sv-qv-close></div>' +
      '<div class="sv-qv__dialog" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button class="sv-qv__close" data-sv-qv-close aria-label="Close">×</button>' +
        '<div class="sv-qv__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-sv-qv-close]')) closeQV(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });
  }
  function openQV() { if (!modal) buildModal(); modal.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden'; }
  function closeQV() { if (modal) { modal.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; } }

  function renderQV(p) {
    var body = modal.querySelector('.sv-qv__body');
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var groups = names.map(function (name, i) {
      var vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]); });
      return { name: name, pos: i + 1, values: vals };
    });
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = money(p.price);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      price = '<span class="sv-qv__now">' + money(p.price) + '</span> <s class="sv-qv__mrp">' + mrp(p.compare_at_price) + '</s>';
    }
    var opts = groups.map(function (g) {
      return '<div class="sv-qv__opt" data-pos="' + g.pos + '"><span class="sv-qv__optlabel">' + esc(g.name) + '</span><div class="sv-qv__pills">' +
        g.values.map(function (val) {
          return '<button type="button" class="sv-qv__pill" data-opt="' + g.pos + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') + '</div></div>';
    }).join('');
    body.innerHTML =
      '<div class="sv-qv__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
      '<div class="sv-qv__info">' +
        '<h2 class="sv-h3 sv-qv__title">' + esc(p.title) + '</h2>' +
        '<p class="sv-qv__price">' + price + '</p>' +
        '<p class="sv-qv__fabric">100% Pima Cotton</p>' + opts +
        '<button type="button" class="sv-btn sv-btn--block sv-qv__add">Select options</button>' +
        '<a href="' + esc(p.url) + '" class="sv-qv__link">View full details</a>' +
      '</div>';

    var sel = {};
    groups.forEach(function (g) { if (g.values.length === 1) sel[g.pos] = g.values[0]; });
    var addBtn = body.querySelector('.sv-qv__add');
    var mediaImg = body.querySelector('.sv-qv__media img');
    function updateImage() {
      if (!mediaImg) return;
      // Swap to the image of a variant matching the current selection (e.g. colour);
      // unselected options act as wildcards so a colour pick alone updates the photo.
      var m = p.variants.find(function (v) {
        return v.featured_image && groups.every(function (g) { return sel[g.pos] == null || v.options[g.pos - 1] === sel[g.pos]; });
      });
      if (m && m.featured_image) {
        var src = m.featured_image.src || m.featured_image;
        if (src) mediaImg.src = src;
      }
    }
    function resolve() {
      updateImage();
      body.querySelectorAll('.sv-qv__opt.is-missing').forEach(function (o) { o.classList.remove('is-missing'); });
      addBtn.classList.remove('is-incomplete');
      // Options still to choose — keep the button tappable so a click can point the
      // shopper at the missing option (rather than silently doing nothing).
      var missing = groups.filter(function (g) { return sel[g.pos] == null; });
      if (missing.length) {
        addBtn.classList.add('is-incomplete'); addBtn.disabled = false; addBtn.removeAttribute('data-id');
        addBtn.textContent = missing.length === 1 ? ('Select ' + missing[0].name) : 'Select Options';
        return;
      }
      var match = p.variants.find(function (v) { return groups.every(function (g) { return v.options[g.pos - 1] === sel[g.pos]; }); });
      if (!match) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; addBtn.removeAttribute('data-id'); return; }
      if (!match.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; addBtn.removeAttribute('data-id'); return; }
      addBtn.disabled = false; addBtn.textContent = 'Add to Bag'; addBtn.setAttribute('data-id', match.id);
    }
    body.querySelectorAll('.sv-qv__pill').forEach(function (pill) {
      var pos = pill.getAttribute('data-opt');
      if (sel[pos] === pill.getAttribute('data-val')) pill.classList.add('is-active');
      pill.addEventListener('click', function () {
        sel[pos] = pill.getAttribute('data-val');
        body.querySelectorAll('.sv-qv__pill[data-opt="' + pos + '"]').forEach(function (x) { x.classList.remove('is-active'); });
        pill.classList.add('is-active');
        resolve();
      });
    });
    addBtn.addEventListener('click', function () {
      var id = addBtn.getAttribute('data-id');
      if (id) { addToCart(id, addBtn).then(closeQV); return; }
      // Incomplete: nudge the shopper toward the first option they haven't picked.
      var missing = groups.filter(function (g) { return sel[g.pos] == null; });
      if (missing.length) {
        var wrap = body.querySelector('.sv-qv__opt[data-pos="' + missing[0].pos + '"]');
        if (wrap) { wrap.classList.remove('is-missing'); void wrap.offsetWidth; wrap.classList.add('is-missing'); }
      }
    });
    resolve();
  }

  function openQuickView(handle) {
    if (!handle) return;
    openQV();
    var body = modal.querySelector('.sv-qv__body');
    body.innerHTML = '<p class="sv-qv__loading">Loading…</p>';
    fetch(ROOT + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(renderQV)
      .catch(function () {
        body.innerHTML = '<p class="sv-qv__loading">Couldn’t load this product. <a href="' + ROOT + 'products/' + handle + '">Open the product page →</a></p>';
      });
  }

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-sv-quickview]');
    if (!qv) return;
    e.preventDefault();
    openQuickView(qv.getAttribute('data-sv-handle'));
  });
})();
